import { render, staticRenderFns } from "./PublicClubs.vue?vue&type=template&id=ef63f0fa&"
import script from "./PublicClubs.vue?vue&type=script&lang=ts&"
export * from "./PublicClubs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports